import { getData, postData } from 'src/api/http.service';
import { handleApiError, handleApiSuccess } from 'src/utils/general.utils';
import { ApiCallFailedAction, ApiCallInProgress, ApiCallSuccessAction } from './uistate.action';

export const LegalPageActionTypes = {
  GET_ALL_TNC: '[API] : Get all the tnc',
  UPDATE_TNC: '[UI] : Update TNC',
};

/*
  Plain Actions
*/

export function GetAllTncSuccessAction(payload) {
  return {
    type: LegalPageActionTypes.GET_ALL_TNC,
    payload,
  };
}

export function UpdateTncSuccessAction(payload) {
  return {
    type: LegalPageActionTypes.UPDATE_TNC,
    payload,
  };
}

/*
  Async Actions
*/

export function GetAllTncAction(url, headers, metaData) {
  return async dispatch => {
    try {
      dispatch(ApiCallInProgress());
      const response = await getData(url, headers);
      dispatch(GetAllTncSuccessAction(response.data));
      dispatch(ApiCallSuccessAction(handleApiSuccess(response, metaData)));
      return true;
    } catch (err) {
      dispatch(ApiCallFailedAction(handleApiError(err, metaData)));
      return false;
    }
  };
}

export function UpdateTncAction(url, body, headers, metaData) {
  return async dispatch => {
    try {
      dispatch(ApiCallInProgress());
      const response = await postData(url, body, headers);
      dispatch(UpdateTncSuccessAction(response.data));
      dispatch(ApiCallSuccessAction(handleApiSuccess(response, metaData)));
      return response.data;
    } catch (err) {
      dispatch(ApiCallFailedAction(handleApiError(err, metaData)));
      return false;
    }
  };
}
